import tradeLinks from './messages/tradeLinks';
import sellerLinks from './messages/sellerLinks';
import companyLinks from './messages/companyLinks';
import socialLinks from './messages/socialLinks';
import legalLinks from './messages/legalLinks';
import sitemapLinks from './messages/sitemapLinks';
import appLink from './messages/appLink';
import { connectLinks, ampConnectLinks } from './messages/connectLinks';

export {
    tradeLinks,
    sellerLinks,
    companyLinks,
    socialLinks,
    sitemapLinks,
    appLink,
    legalLinks,
    connectLinks,
    ampConnectLinks,
};
